import React from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';

const TwoColumnView = () => {
  return (
    <div
      style={{
        display: 'block',
        lineHeight: 2.5,
        padding: '1rem',
        marginBottom: '3rem',
      }}
    >
      <Skeleton count={5} height={50} />
    </div>
  );
};

export default TwoColumnView;
